// extracted by mini-css-extract-plugin
export default {"row":"Card_row__s0Wjn","card":"Card_card__HxW3D","info":"Card_info__BzDg2","label":"Card_label__3fWuC","content":"Card_content__9-wa9"};